import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../services/api";
import { DashboardLayout, MainContent } from "../dash/styles";
import Sidebar from "../../components/sidebar/Sidebar";
import Header from "../../components/conquistas/header/Header";
import Midia from "../../components/conquistas/midia/Midia";
import ActionFooter from "../../components/actionFooter/ActionFooter";
import DetalhesConquista from "../../components/conquistas/detalhesConquista/DetalhesConquista";
import { Container } from "./styles";
import dayjs from "dayjs";


const getImagemUrl = (imagem) => {
  if (!imagem) return "https://placehold.co/600x200?text=Sem+Imagem";
  if (imagem.startsWith("http")) return imagem;

  const baseURL = api.defaults.baseURL;
  return `${baseURL}/${imagem.replace(/^\/?/, "")}`;
};

const normalizeTags = (tags) => {
  if (!tags) return [];
  if (Array.isArray(tags)) return tags.map((t) => t.trim());
  if (typeof tags === "string") {
    try {
      return JSON.parse(tags);
    } catch {
      return [];
    }
  }
  return [];
};

export default function EditarConquistas() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [conquistaData, setConquistaData] = useState(null);
  const [loading, setLoading] = useState(true);

  /* 🔹 Buscar conquista */
  useEffect(() => {
    const fetchConquista = async () => {
      try {
        const response = await api.get(`/api/achievements/${id}`);
        const c = response.data;

        setConquistaData({
          titulo: c.titulo || "",
          descricao: c.descricao || "",
          xp: c.xp || 0,
          ativa: Boolean(c.ativa),
          tags: normalizeTags(c.tags),
          criterioDesbloqueio: c.criterioDesbloqueio || {
            acao: "",
            quantidade: 0,
            tipo: "",
          },
          imagem: c.imagem || null,
          preview: getImagemUrl(c.imagem),
        });
      } catch (error) {
        console.error("Erro ao buscar conquista:", error);
        alert("Conquista não encontrada.");
        navigate("/conquistas");
      } finally {
        setLoading(false);
      }
    };

    fetchConquista();
  }, [id, navigate]);

  /* 🔹 Salvar alterações */
  const handleSave = async () => {
    if (!conquistaData) return;

    const formData = new FormData();
    formData.append("titulo", conquistaData.titulo);
    formData.append("descricao", conquistaData.descricao);
    formData.append("xp", String(conquistaData.xp));
    formData.append("ativa", String(conquistaData.ativa));
    formData.append("tags", JSON.stringify(conquistaData.tags || []));
    formData.append(
      "criterioDesbloqueio",
      JSON.stringify(conquistaData.criterioDesbloqueio)
    );

    if (conquistaData.imagem instanceof File) {
      formData.append("imagem", conquistaData.imagem);
    }

    try {
      await api.put(`/api/achievements/${id}`, formData);
      alert("Conquista atualizada com sucesso!");
      navigate("/conquistas");
    } catch (error) {
      console.error("Erro ao atualizar conquista:", error);
      alert("Erro ao salvar alterações.");
    }
  };

  if (loading) return <p style={{ padding: 40 }}>Carregando conquista...</p>;
  if (!conquistaData) return <p style={{ padding: 40 }}>Conquista não encontrada.</p>;

  return (
    <DashboardLayout>
      <Sidebar />
      <Container>
        <Header
          title="Editar Conquista"
          description="Atualize as informações da conquista"
          breadcrumbMain="conquistas"
          breadcrumbCurrent="Editar Conquista"
        />
        <MainContent>
          <Midia
            initialPreview={conquistaData.preview}
            onFileSelect={(file, preview) =>
              setConquistaData({ ...conquistaData, imagem: file, preview })
            }
          />
          <DetalhesConquista
            conquistaData={conquistaData}
            setConquistaData={setConquistaData}
          />
          <ActionFooter onSave={handleSave} />
        </MainContent>
      </Container>
    </DashboardLayout>
  );
}
